import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Onboarding.css";
import { markOnboardingCompleted, shouldShowOnboarding } from "./onboardingUtils";

const slides = [
  {
    title: "Welcome to Pyate",
    description: "Discover trusted businesses, connect with people, and grow your network in one place."
  },
  {
    title: "Set up your store profile",
    description: "Add your store details, products, posts, and team information with ease."
  },
  {
    title: "Sell smarter",
    description: "Manage shop items, track orders, and handle cart and wishlist in one workflow."
  },
  {
    title: "Get instant help with chatbot",
    description: "Ask about products, orders, and store updates anytime and get quick guidance."
  }
];

const Onboarding = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || "/home";
  const userId = localStorage.getItem("user_id");
  const activeSlide = useMemo(() => slides[activeIndex], [activeIndex]);
  const isLastSlide = activeIndex === slides.length - 1;

  const finishOnboarding = () => {
    markOnboardingCompleted(userId);
    navigate(from, { replace: true });
  };

  const goNext = () => {
    if (isLastSlide) {
      finishOnboarding();
      return;
    }
    setActiveIndex((current) => current + 1);
  };

  useEffect(() => {
    if (!shouldShowOnboarding(userId)) {
      navigate(from, { replace: true });
    }
  }, [from, navigate, userId]);

  if (!shouldShowOnboarding(userId)) return null;

  return (
    <div className="onboarding-container">
      <div className="onboarding-card">
        <div className="onboarding-progress">
          {slides.map((_, idx) => (
            <span
              key={idx}
              className={`onboarding-dot ${idx === activeIndex ? "active" : ""}`}
            />
          ))}
        </div>

        <h1 className="onboarding-title">{activeSlide.title}</h1>
        <p className="onboarding-description">{activeSlide.description}</p>

        <div className="onboarding-actions">
          <button type="button" className="onboarding-skip" onClick={finishOnboarding}>
            Skip
          </button>
          <button type="button" className="onboarding-next" onClick={goNext}>
            {isLastSlide ? "Done" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
